import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { maybeFormatPrefixedMessage } from 'utils/i18nUtils';

import NewsLink from './components/NewsLink/NewsLink';
import {
  Content,
  StyledBackgroundSection,
  Headline,
} from './styles/Container';

function SectionLearnMore({
  content,
  prefix,
  imagePath,
  hasHeadline,
  className,
}) {
  const intl = useIntl();
  const i18nPrefix = prefix;
  const prefixNews = maybeFormatPrefixedMessage(intl, i18nPrefix);

  return (
    <StyledBackgroundSection
      backgroundImagePath={`${imagePath}@0.75x.jpg`}
      backgroundImagePathMobile={`${imagePath}@0.5x.jpg`}
      backgroundImagePathDesktop={`${imagePath}@1x.jpg`}
      className={className}
    >
      {hasHeadline
        && (
        <Headline>
          <Typography
            variant="supertitle"
            intlKey={`${prefix}.HEADLINE`}
            color="white"
          />
        </Headline>
        )}
      <Content hasHeadline={hasHeadline}>
        <Typography
          variant="title"
          intlKey={`${prefix}.TITLE`}
        />
        {content.map(news => (
          <NewsLink
            title={prefixNews(`${news}.TITLE`)}
            href={prefixNews(`${news}.LINK`)}
            key={news}
          />
        ))}

      </Content>

    </StyledBackgroundSection>
  );
}

SectionLearnMore.defaultProps = {
  className: undefined,
  hasHeadline: false,
};

SectionLearnMore.propTypes = {
  className: PropTypes.string,
  content: PropTypes.arrayOf(PropTypes.string).isRequired,
  hasHeadline: PropTypes.bool,
  imagePath: PropTypes.string.isRequired,
  prefix: PropTypes.string.isRequired,
};

export default memo(SectionLearnMore);
